module.exports = __webpack_public_path__ + "static/alternativetimes-e8429c0805ce9f399ba189f0ecc6812c.png";